import React from "react";
import classnames from "classnames";

const Row = ({ children, type = "row-start-center", className = "" }) => {
	return <div className={classnames(`${type} ${className}`)}>{children}</div>;
};

export default Row;
